export { default } from './ModalListRewardsClaimed';
